import MailchimpFormContainer from './MailchimpFormContainer';
import { useState } from 'react';
import uno from '../assets/img/screens/1.svg';
import cuatro from '../assets/img/screens/4.svg';


export default function MainHero() {

    const [showModal, setShowModal] = useState(false);

    function showModalHandler() {
        setShowModal(true);
        console.log(showModal)
    }
    function hideModalHandler() {
        setShowModal(false);
    }

    return (
        <>
            {showModal && <MailchimpFormContainer onClose={hideModalHandler}></MailchimpFormContainer>}
            <div className='bg-gray-100'>
                <main className="lg:relative">
                    <div className="px-13 mx-auto max-w-7xl w-full pt-12 pb-20 text-center lg:py-28 lg:text-left">
                        <div className="px-4 lg:w-1/2 md:w-1/2 sm:px-8 xl:pr-2">
                            <h1 className="py-2 text-6XL tracking-tight font-jakarta font-bold text-transparent bg-clip-text bg-gradient-to-r from-black to-tonder-blue sm:text-6xl pb-5 md:text-6xl text-5xl xl:text-6xl">
                                <span>Harmonize your</span>
                                <br ></br>
                                <span>
                                    payment ecosystem
                                </span>
                            </h1>
                            <div className="relative w-full xl:h-64 sm:h-72 md:h-46 md:absolute lg:-top-12 lg:-right-96 lg:w-11/12 lg:h-11/12 flex items-center">
                                <img
                                     className="xl:absolute inset-y-0 md:absolute md:right-16 md:mb-72 xl:mb-44 xl:inset-0 lg:mt-32 xl:w-7/12 lg:w-11/12 md:w-6/12 content-center m-auto"
                                     src={require('../assets/img/device_2.png')}
                                     alt="device"
                                />
                            </div>
                            <p className="font-jakarta xl:text-sm xl:max-w-full lg:max-w-full xl:pr-14 xl:text-left xl:mt-10 md:mt-4 max-w-md mx-auto text-sm text-[#2f2f2f] sm:text-xl my-2">
                            Our unified payment platform helps your business have better acceptance rates, minimize fraud and manage your full payment stack in one place.</p>
                            <div className="xl:mt-10 mt-4 space-x-6  flex  justify-center lg:justify-start">
                                <div className="rounded-md ">
                                    <button
                                        onClick={showModalHandler}
                                        className="transition ease-in-out hover:scale-105 text-sm flex items-center justify-center px-4 py-4  font-medium rounded-md text-white bg-tonder-blue  ">
                                                 Get in touch with our team
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>

                <div className='max-w-7xl flex h-11/12 w-11/12 m-auto xl:mt-20'>
                    <div className=" mr-5 bg-white rounded-3xl">
                        <img
                            src={uno}
                            alt="Connect-payment"
                        />
                    </div>
                    <div className="">
                        <img

                            src={require('../assets/img/screens/2.png')}
                            alt="Increase-sales"
                        />
                    </div>
                </div>

                <div className='relative max-w-7xl payment-review m-auto mt-11'>
                    <button
                        onClick={showModalHandler}
                        className="absolute bottom-4 xl:bottom-16 md:bottom-20 ml-2 xl:ml-9 md:ml-4 px-4 py-2  xl:px-12 xl:py-4 text-xs font-medium rounded-md text-white bg-tonder-blue md:text-lg "
                    >
                        Get started
                    </button>
                </div>

                <div className='max-w-7xl xl:mt-11 mt-4 h-11/12 w-11/12 m-auto bg-white rounded-3xl'> 
                    <img
                        className=""
                        src={cuatro}
                        alt="tonder_checkout"
                    />
                </div>

                <div className='flex h-11/12 w-full m-auto mt-11'>
                    <div className="mr-6">
                        <img
                            src={require('../assets/img/screens/5.png')}
                            alt="Connect-payment"
                        />
                    </div>
                    <div className="">
                        <img

                            src={require('../assets/img/screens/6.png')}
                            alt="Increase-sales"
                        />
                    </div>
                </div>

                <div className='max-w-7xl mt-11 h-11/12 w-11/12 m-auto'>
                    <img
                        className=""
                        src={require('../assets/img/screens/7.png')}
                        alt="tonder_checkout"
                    />
                </div>

                <div className='max-w-7xl mt-40 w-11/12 m-auto'>
                    <p className='text-2xl tracking-tight font-jakarta  font-bold  text-gray-900'>Tonder up your business</p>
                    <br></br>
                    <h1 className=" text-4xl tracking-tight font-jakarta font-bold  text-gray-900 sm:text-5xl md:text-6xl text-5xl xl:text-6xl">
                        <span >Create an account now.
                            <span className="text-4xl tracking-tight font-jakarta  font-bold  text-[#bfbfbf] sm:text-5xl md:text-6xl text-5xl xl:text-6xl">
                                {"\u00a0\u00a0"}Start giving
                            </span> </span>
                        <br></br>
                        <p className="mt-4 text-4xl tracking-tight font-jakarta  font-bold  text-[#bfbfbf] sm:text-5xl md:text-6xl text-5xl xl:text-6xl">
                            shoppers the best paying experience
                        </p>
                        <p className="mt-4 text-4xl tracking-tight font-jakarta  font-bold  text-[#bfbfbf] sm:text-5xl md:text-6xl text-5xl xl:text-6xl">
                            today.
                        </p>
                    </h1>
                    <div className="rounded-md mt-10">

                        <button
                            onClick={showModalHandler}
                            className="text-sm  px-10 py-4  font-medium rounded-md text-white bg-tonder-blue "
                        >
                            Connect your business
                        </button>
                    </div>
                </div>
            </div>
        </>

    );
}
